<template>
  <div class="row g-3">
    <div class="col-12">
      <WidgetCard title="Receita Recorrente Mensal (MRR)">
        <ChartLine :data="mrr" :options="moneyOptions" />
      </WidgetCard>
    </div>
    <div class="col-12">
      <WidgetCard title="Faturamento e Lucro de Consultas">
        <ChartLine :data="revenueProfit" :options="moneyOptions" />
      </WidgetCard>
    </div>
  </div>
</template>

<script>
import { COLORS, moneyBR, baseOptions, dateTicks } from "@/utils/dashboardCharts";
import WidgetCard from "./WidgetCard.vue";

export default {
  name: "DashFinancial",
  components: { WidgetCard },
  props: { data: { type: Object, required: true } },
  data() {
    return {
      moneyOptions: {
        ...baseOptions,
        scales: {
          xAxes: [{ ticks: dateTicks }],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (v) => moneyBR(v),
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: (item, d) => {
              const ds = d.datasets[item.datasetIndex];
              return `${ds.label}: ${moneyBR(item.yLabel)}`;
            },
          },
        },
      },
    };
  },
  computed: {
    mrr() {
      const rows = this.data.mrr_timeline || [];
      return {
        labels: rows.map((r) => r.year_month),
        datasets: [
          {
            label: "MRR ativo",
            data: rows.map((r) => Number(r.mrr_active)),
            borderColor: COLORS[1],
            backgroundColor: COLORS[1],
            pointBackgroundColor: "#fff",
            pointRadius: 3,
            fill: false,
          },
        ],
      };
    },
    revenueProfit() {
      const rows = this.data.appointments_revenue_timeline || [];
      return {
        labels: rows.map((r) => r.year_month),
        datasets: [
          {
            label: "Faturamento (volume)",
            data: rows.map((r) => Number(r.revenue)),
            borderColor: COLORS[1],
            backgroundColor: COLORS[1],
            pointBackgroundColor: "#fff",
            pointRadius: 3,
            fill: false,
          },
          {
            label: "Lucro (comissão)",
            data: rows.map((r) => Number(r.profit)),
            borderColor: COLORS[3],
            backgroundColor: COLORS[3],
            pointBackgroundColor: "#fff",
            pointRadius: 3,
            fill: false,
          },
        ],
      };
    },
  },
};
</script>
